import React, { useState, useEffect, useRef } from 'react';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { Portal } from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import DumperIcon from '../icons/DumperIcon';
import DumperTipIcon from '../icons/DumperTipIcon';
// import DumperRotateIcon from '../icons/DumperSwivalIcon';
import DumperFollowMeIcon from '../icons/DumperFollowMeIcon';
import DumperGoToIcon from '../icons/DumperGoToIcon';
import UserManagementIcon from '../icons/UserManagementIcon';
import ResetIcon from '../icons/ResertIcon';
// import ItarraIcon from '../icons/ItarraIcon';
import LightsIcon from '../icons/LightsIcon';
// import HydralicSpoolValveIcon from '../icons/HydralicSpoolValveIcon';
// import SinglePhaseIcon from '../icons/SinglePhaseIcon';
// import ThreePhaseIcon from '../icons/ThreePhaseIcon';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
// import RearLinkageIcon from '../icons/RearLinkage';
// import FrontLinkageIcon from '../icons/FrontLinkage';
import LightsComponent from './LightsComponent';
// import HydraulicsComponent from './HydraulicsComponent';
// import TiltIcon from '../icons/TiltIcon';
// import { FollowTheSigns } from '@mui/icons-material';

const MenuContainer = styled(Paper)(({ theme, width }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.background.paper,
  zIndex: 99999, // 👈 always on top
  width: width,
}));

const StyledTypography = styled(Typography)({
  textAlign: 'center',
  width: '100%',
  marginTop: '-5px',
});

const CenterButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(2),
  left: theme.spacing(2),
  zIndex: 100000, // 👈 button is even higher so it's always clickable
}));

const MenuItem = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  border: '1px solid white',
  margin: theme.spacing(1),
  width: '80px',
  height: '80px',
  cursor: 'pointer',
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
}));

const SquareMenu = ({ setMenu }) => {
  const [open, setOpen] = useState(false);
  const [containerWidth, setContainerWidth] = useState('auto');
  const [selectedItem, setSelectedItem] = useState(null);
  const containerRef = useRef(null);

  const toggleMenu = () => setOpen(!open);

  const menuItems = [
    { icon: <DumperIcon size={50}/>, text: 'Drive', margin: '-5px' },
    { icon: <LightsIcon size={30} />, text: 'Lights', margin: '-5px' },
    { icon: <DumperTipIcon size={50} />, text: 'T&R', margin: '-5px' },
    // { icon: <DumperRotateIcon size={50} />, text: 'Rotate', margin: '-5px' },
    { icon: <DumperFollowMeIcon size={50} />, text: 'Follow_Me', margin: '-5px' },
    { icon: <DumperGoToIcon size={45} />, text: 'GoTo', margin: '-5px' },
    { icon: <UserManagementIcon size={30} />, text: 'Users', margin: '-5px' },
    { icon: <ResetIcon size={30} />, text: 'Reset', margin: '-5px' },
    { icon: <ExitToAppIcon />, text: 'Exit', margin: '-5px' },
  ];

  const handleItemClick = (item) => {
    if (
      item !== 'Exit' &&
      item !== 'Drive' &&
      item !== 'T&R' &&
      item !== 'Rotate' &&
      item !== 'Follow_Me' &&
      item !== 'GoTo' 
    ) {
      setSelectedItem(item);
    } else {
      setMenu(item);
      setSelectedItem(null);
      toggleMenu();
    }
  };

  const handleBackToMenu = () => {
    setSelectedItem(null);
    setOpen(true);
  };

  useEffect(() => {
    if (containerRef.current) {
      const itemWidth = 80;
      const padding = 20;
      const numItems = 3;
      const totalPadding = padding * (numItems + 1);
      const width = numItems * itemWidth + totalPadding + 40;
      setContainerWidth(`${width}px`);
    }
  }, [open]);

  return (
    <>
      <CenterButton color="primary" onClick={toggleMenu} size="large">
        <MenuIcon />
      </CenterButton>

      {open && (
        <Portal>
          <MenuContainer elevation={4} ref={containerRef} width={containerWidth}>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              {menuItems.map((item, index) => (
                <Grid item xs={4} key={index}>
                  <Tooltip title={item.text}>
                    <MenuItem onClick={() => handleItemClick(item.text)}>
                      <IconButton color="default">{item.icon}</IconButton>
                      <StyledTypography
                        variant="caption"
                        style={{ fontSize: 10, marginTop: item.margin }}
                      >
                        {item.text}
                      </StyledTypography>
                    </MenuItem>
                  </Tooltip>
                </Grid>
              ))}
            </Grid>
          </MenuContainer>
        </Portal>
      )}

      {selectedItem && (
        <Portal>
          <MenuContainer elevation={4} width={containerWidth}>
            {selectedItem === 'Lights' && (
              <LightsComponent
                Icon={LightsIcon}
                label="Lights"
                onBackToMenu={handleBackToMenu}
              />
            )}
            {/* {selectedItem === 'Single Phase' && (
              <LightsComponent
                Icon={SinglePhaseIcon}
                label="Single Phase"
                onBackToMenu={handleBackToMenu}
              />
            )}
            {selectedItem === 'Three Phase' && (
              <LightsComponent
                Icon={ThreePhaseIcon}
                label="Three Phase"
                onBackToMenu={handleBackToMenu}
              />
            )}
            {selectedItem === 'Hydraulics' && (
              <HydraulicsComponent
                onBackToMenu={handleBackToMenu}
                handleItemClick={handleItemClick}
              />
            )} */}
          </MenuContainer>
        </Portal>
      )}
    </>
  );
};

export default SquareMenu;
